import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useNavigate, useParams} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useCreateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";
import * as dangerEvaluationCheckItem from "../../api/permissionApi/dangerEvaluationCheckItem";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";

import {FormSection} from "../../styledComponents/StyledCreateForm";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import CheckItemForm from "./CheckItemForm";
import {WPCheckItem, initializeCheckItem} from "../../models/serverModels/permission/WPCheckItem";

const checkItemSchema = yup.object({
  name: yup.string().required("아이템명을 입력해주세요"),
  displayOrder: yup.number(),
});

const CreateCheckItem = () => {
  const {id} = useParams();

  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: createMutate, isLoading} = useCreateMutation<
    ResponseItem<WPCheckItem>,
    Params.Create<WPCheckItem>
  >({
    api: dangerEvaluationCheckItem.create,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate(`/Permission/CheckItemList/${id}`);
        queryClient.invalidateQueries("CheckItemList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });
  const methods = useForm<WPCheckItem>({
    defaultValues: initializeCheckItem(),
    resolver: yupResolver(checkItemSchema),
  });

  const onSubmit: SubmitHandler<WPCheckItem> = (data) => {
    createMutate({
      token: tokenState,
      item: {...initializeCheckItem(), ...data, categoryIndex: parseInt(id!)},
    });
  };

  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="유해위험요인 추가" />
      {isLoading && <MWProgress />}
      <FormSection>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <CheckItemForm />
          <ConfirmButtonGroup
            link={`/Permission/CheckItemList/${id}`}
            cancelText="취소"
            confirmText="추가"
          />
        </form>
      </FormSection>
    </FormProvider>
  );
};

export default CreateCheckItem;
